var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AnimatedNumber"},[(_vm.showPlus && _vm.valueInt > 0)?_c('span',[_vm._v("+")]):_vm._e(),(_vm.show && (!_vm.hideZero || _vm.valueInt != 0))?_c('span',[_vm._v(" "+_vm._s(_vm.valueInt)+" ")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }